export default __webpack_public_path__ + "static/media/bg3_m.e6d8c9bf.png";